import { render, staticRenderFns } from "./paySucceed.vue?vue&type=template&id=0cbb3126&scoped=true&"
import script from "./paySucceed.vue?vue&type=script&lang=js&"
export * from "./paySucceed.vue?vue&type=script&lang=js&"
import style0 from "./paySucceed.vue?vue&type=style&index=0&id=0cbb3126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbb3126",
  null
  
)

export default component.exports